var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"timeline-minimap"},[_c('div',{staticClass:"timeline-minimap__sequence",style:({
      'left': (_vm.minimapSequenceStart + "%"),
      'width': (_vm.minimapSequenceWidth + "%"),
    })}),_vm._l((_vm.blackholes),function(style,index){return _c('div',{key:index,staticClass:"timeline-minimap__blackhole",style:(style)})}),_c('div',{ref:"marker",staticClass:"timeline-minimap__marker",style:({
      'left': (_vm.minimapMarkerPos + "%"),
    })})],2)}
var staticRenderFns = []

export { render, staticRenderFns }